import { render, staticRenderFns } from "./WidgetFormItem.vue?vue&type=template&id=fad7e530"
import script from "./WidgetFormItem.vue?vue&type=script&lang=js"
export * from "./WidgetFormItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports